import { useRouter } from 'next/router'

import { HotelBookingBar as _HotelBookingBar } from 'bl-flows/src/flows/hotel/components/HotelBookingBar'
import { HOTEL_BOOKING_BAR_STATE_SCHEMA } from 'bl-flows/src/flows/hotel/constants'
import { Property } from 'bl-graphql'
import { useURLState } from 'flow-builder/src/hooks/useUrlState'
import { queryTypes, serializeState } from 'flow-builder/src/utils/urlState'

import { isProperty } from 'utils/isProperty'

export const HotelBookingBar = ({
  ctaLabel,
  property,
  switchBetweenPanels = false,
  mobileBarAsButton = false,
  maxDate = undefined,
}) => {
  const router = useRouter()

  const schema = {
    ...HOTEL_BOOKING_BAR_STATE_SCHEMA,
    ...(isProperty(property) && {
      property: queryTypes
        .stringEnum<Property>(Object.values(Property))
        .withDefault(property),
    }),
  }
  const [hotelBookingBarState, setHotelBookingBarState] = useURLState(schema)

  return (
    <_HotelBookingBar
      state={hotelBookingBarState}
      ctaLabel={ctaLabel}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onChange={newState => {
        setHotelBookingBarState(
          {
            ...hotelBookingBarState,
            ...newState,
            dates: newState.dates?.filter(Boolean),
          },
          'replace',
          {
            shallow: true,
          }
        )
      }}
      onApply={newState => {
        router.push(
          {
            pathname: '/book/accommodation',
            search: `${serializeState(schema, newState)}`,
          },
          null,
          { shallow: true }
        )
      }}
      switchBetweenPanels={switchBetweenPanels}
      mobileBarAsButton={mobileBarAsButton}
      maxDate={maxDate}
    />
  )
}

export default HotelBookingBar
